import React from 'react';
import './terms.css';
import { FaLongArrowAltRight } from "react-icons/fa";
import { motion } from "motion/react"
function Terms() {
  const terms = [
    {
      label: 'Issuer',
      value: 'Boch Investment Fund, LLC'
    },
    {
      label: 'Offering Type',
      value: 'Regulation D, Rule 506(c) — Private Placement'
    },
    {
      label: 'Security Type',
      value: 'Membership Interests'
    },
    {
      label: 'Maximum Offering',
      value: '$6,000,000',
      highlight: true
    },
    {
      label: 'Target Offering',
      value: '$3,000,000',
      highlight: true
    },
    {
      label: 'Minimum Investment',
      value: '$100,000',
      highlight: true
    }
  ];

  return (
    <motion.section id="terms" className="terms-section">
    <motion.span
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.8 }}
    viewport={{ once: true }}
    style={{ display: "block" }}
  >
      <div className="terms-glow terms-glow-one"></div>
      <div className="terms-glow terms-glow-two"></div>

      <div className="container position-relative">

        <div className="row g-5 align-items-center">

          {/* LEFT COLUMN */}
          <div className="col-12 col-lg-5">

            <div className="terms-intro">

              <div className="section-label">
                <span></span>
                OFFERING TERMS
              </div>

              <h2 className="terms-title">
                Terms of the
                <br />
                <span>Offering</span>
              </h2>

              <div className="title-line"></div>

              <p className="terms-description">
                This offering is conducted pursuant to Regulation D, Rule
                506(c) under the Securities Act of 1933, as amended.
                Securities are offered exclusively to verified accredited
                investors. Investors must complete accreditation verification
                prior to receiving subscription documents.
              </p>

              {/* Accreditation Card */}

              <div className="investor-accreditation">

                {/* <div className="accreditation-icon">
                  <i className="fa fa-shield"></i>
                </div> */}

                <div className="accreditation-content">

                  <h5>
                    ACCREDITED INVESTOR
                    <br />
                    REQUIREMENTS
                  </h5>

                  <p>
                    To qualify as an accredited investor, you must meet one
                    of the following: individual net worth exceeding
                    $1,000,000 excluding primary residence; individual
                    income exceeding $200,000 in each of the two most recent
                    years; or joint income exceeding $300,000 with a spouse
                    or spousal equivalent.
                  </p>

                </div>

              </div>

              {/* CTA */}

              <div className="invest-button-wrapper">

                <a
                  href="signup"
                  className="invest-btn"
                >
                  <span>INVEST NOW</span>

                  <FaLongArrowAltRight />
                </a>

              </div>

            </div>

          </div>


          {/* RIGHT COLUMN */}

          <div className="col-12 col-lg-7">

            <div className="terms-panel">

              <div className="terms-panel-header">

                <div>
                  <span className="panel-label">
                    INVESTMENT OVERVIEW
                  </span>

                  <h4>
                    Offering Details
                  </h4>
                </div>

                <div className="panel-status">
                  OPEN
                </div>

              </div>


              <div className="terms-table">

                {terms.map((term, index) => (

                  <div
                    className="terms-row"
                    key={index}
                  >

                    <div className="terms-label">
                      {term.label}
                    </div>

                    <div
                      className={`terms-value ${
                        term.highlight
                          // ? 'highlight-val'
                          // : ''
                      }`}
                    >
                      {term.value}
                    </div>

                  </div>

                ))}

              </div>

            </div>

          </div>

        </div>

      </div>
</motion.span>
    </motion.section>
  );
}

export default Terms;